/**
 * Collects what holds memory during an assembly — opened inputs, decoded frames, canvases — and frees it in reverse
 * order. A release that throws does not stop the others: the point is that nothing stays behind.
 */
export class ReleaseBag {
  private releases: Array<() => void> = [];

  add(release: () => void): void {
    this.releases.push(release);
  }

  releaseAll(): void {
    const releases = this.releases.reverse();
    this.releases = [];
    for (const release of releases) {
      try {
        release();
      } catch {
        // already released
      }
    }
  }
}
